export const MONTH_LABELS_LONG = [
    "janeiro", "fevereiro", "março", "abril", "maio", "junho",
    "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
];

export const MONTH_LABELS_SHORT = [
    "jan.", "fev.", "mar.", "abr.", "mai.", "jun.",
    "jul.", "ago.", "set.", "out.", "nov.", "dez.",
];

export const WEEKDAY_LABELS = ["D", "S", "T", "Q", "Q", "S", "S"];

export function pad2(n) {
    return String(n).padStart(2, "0");
}

export function startOfDay(d) {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
}

export function endOfDay(d) {
    const x = new Date(d);
    x.setHours(23, 59, 59, 0);
    return x;
}

export function isSameDay(a, b) {
    if (!a || !b) return false;
    return a.getFullYear() === b.getFullYear()
        && a.getMonth() === b.getMonth()
        && a.getDate() === b.getDate();
}

export function isBeforeDay(a, b) {
    if (!a || !b) return false;
    const aT = new Date(a.getFullYear(), a.getMonth(), a.getDate()).getTime();
    const bT = new Date(b.getFullYear(), b.getMonth(), b.getDate()).getTime();
    return aT < bT;
}

export function isAfterDay(a, b) {
    if (!a || !b) return false;
    return isBeforeDay(b, a);
}

export function isBetweenDays(d, from, to) {
    if (!d || !from || !to) return false;
    return !isBeforeDay(d, from) && !isAfterDay(d, to);
}

export function addMonths(d, n) {
    const x = new Date(d.getFullYear(), d.getMonth() + n, 1);
    return x;
}

export function firstDayOfMonth(year, month) {
    return new Date(year, month, 1);
}

/**
 * Returns a 6x7 grid of Date objects for the given year/month, padded by
 * leading days from the previous month and trailing days from the next month.
 */
export function buildMonthMatrix(year, month) {
    const first = firstDayOfMonth(year, month);
    const firstWeekday = first.getDay();
    const start = new Date(year, month, 1 - firstWeekday);

    const cells = [];
    for (let i = 0; i < 42; i += 1) {
        const d = new Date(start.getFullYear(), start.getMonth(), start.getDate() + i);
        cells.push(d);
    }
    const rows = [];
    for (let r = 0; r < 6; r += 1) {
        rows.push(cells.slice(r * 7, r * 7 + 7));
    }
    return rows;
}

export function formatDisplayDate(d) {
    if (!d) return "";
    return `${pad2(d.getDate())} / ${pad2(d.getMonth() + 1)} / ${d.getFullYear()}`;
}

export function parseDisplayDate(text) {
    if (!text) return null;
    const digits = String(text).replace(/\D/g, "");
    if (digits.length !== 8) return null;
    const day = parseInt(digits.slice(0, 2), 10);
    const month = parseInt(digits.slice(2, 4), 10);
    const year = parseInt(digits.slice(4, 8), 10);
    if (!day || !month || !year) return null;
    if (month < 1 || month > 12) return null;
    const date = new Date(year, month - 1, day);
    if (date.getDate() !== day || date.getMonth() !== month - 1) return null;
    return date;
}

export function clampDate(d, min, max) {
    if (!d) return d;
    if (min && isBeforeDay(d, min)) return startOfDay(min);
    if (max && isAfterDay(d, max)) return endOfDay(max);
    return d;
}
